import './TripsPage.less';

import { Card, Space } from 'antd';

import StickyPageHeader from '../components/common/StickyPageHeader';
import TripDisplay from '../components/common/TripDisplay';
import { useTripDelete, useTrips } from '../hooks/apiHooks/trip.';
import Layout from '../layout';

const TripsPage = ({ disableLayout, routes }) => {
  const { loadingTrips, refetch: refetchTrips, trips } = useTrips();
  const { mutate: deleteTrip } = useTripDelete();
  //console.log(trips);

  const tripDeleted = (id) => {
    deleteTrip(id, {
      onError: (error) => {
        console.error('Error deleting trip: ', error);
      },
      onSuccess: () => {
        console.log('Trip deleted!');
        refetchTrips();
      },
    });
  };

  const content = (
    <>
      <StickyPageHeader isAdmin title="Trips" />

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          {loadingTrips && <p>Loading trips...</p>}
          {trips && trips.length > 0 && (
            <>
              {trips.map((nextTrip, i) => (
                <TripDisplay key={i} trip={nextTrip} onDelete={tripDeleted} />
              ))}
            </>
          )}
        </Card>
      </Space>
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout disableLoading showCarriersNavigation menuIndex={0} routes={routes}>
      {content}
    </Layout>
  );
};

export default TripsPage;
